import { environment } from 'environments/environment';
import apiService from 'services/ApiService';
import { logger } from 'utils/logger';

const log = logger.getLogger('ParticipantsService');

const baseUrl = environment.services.participant.baseUrl;
const participantsUrl = baseUrl + environment.services.participant.basePath + '/participants';

export interface ParticipantContact {
  id?: number;
  type: string;
  name?: string;
  value: string;
}

export interface Participant {
  id: number;
  accountId?: number;
  clientId: string;
  first?: string;
  last?: string;
  middle?: string;
  active: boolean;
  createDate?: string;
  updateDate?: string;
  contacts?: ParticipantContact[];
}

export interface SearchParticipantsParams {
  search: string;
  page?: number;
  size?: number;
}

export interface SearchParticipantsResult {
  count: number;
  data: Participant[];
}

export interface RedactRequest {
  participantId?: number;
  email?: string;
}

export interface RedactionServiceResult {
  service: string;
  participantId: number;
  redactedCounts: Record<string, number>;
  status: 'SUCCESS' | 'PARTIAL' | 'FAILURE' | string;
  errors?: string[];
}

export interface RedactParticipantResponse {
  id: number;
  originalEmail: string;
  email: string;
  status: 'SUCCESS' | 'PARTIAL' | 'FAILURE' | string;
  services: RedactionServiceResult[];
}

class ParticipantsService {
  async searchParticipants(params: SearchParticipantsParams): Promise<SearchParticipantsResult> {
    const page = params.page ?? 0;
    const size = params.size ?? 50;
    const url = `${participantsUrl}?search=${encodeURIComponent(params.search)}&page=${page}&size=${size}`;

    log.log('Searching participants:', url);

    const response = await apiService.makeRequest('get', url, undefined, false);

    let data: Participant[] = [];
    let count = 0;
    if (Array.isArray(response)) {
      data = response;
      count = response.length;
    } else if (response && typeof response === 'object') {
      data = response.data || [];
      count = response.count ?? data.length;
    }

    return { data, count };
  }

  async redactParticipant(request: RedactRequest): Promise<RedactParticipantResponse> {
    const url = `${participantsUrl}/redact`;
    log.log('Redacting participant:', request);
    return apiService.makeRequest('post', url, request, false);
  }
}

export const participantsService = new ParticipantsService();
export default participantsService;
